/**
 * Authentication Configuration
 * 
 * Controls whether tenant slug is required for sign-in
 */

export const AUTH_REQUIRE_TENANT_SLUG =
  process.env.NEXT_PUBLIC_AUTH_REQUIRE_TENANT_SLUG === 'true' ||
  process.env.NEXT_PUBLIC_AUTH_REQUIRE_TENANT_SLUG === '1';

/**
 * Check if tenant slug is required for authentication
 */
export function isTenantSlugRequired(): boolean {
  return AUTH_REQUIRE_TENANT_SLUG;
}

